import { useEffect, useMemo, useState } from 'preact/hooks'
import { AccountFitClubCard } from './AccountFitClubCard'
import { session } from '../../../helpers/session'
import { useAccountLayoutContext } from './AccountProfileContext'

/** Global
 * accountGlobal
 */

const YOUR_FIT_CLUB_DATA = {
  heading: accountGlobal?.fitClubCard?.title,
  subtitle: accountGlobal?.fitClubCard?.body,
  cta: {
    text: accountGlobal?.fitClubCard?.cta?.title,
    path: accountGlobal?.fitClubCard?.cta?.url
  }
}

/**
 *
 * @param {{card: {balance: string, id: string, memberSince: string}}} param0
 * @returns
 */
export const AccountYourFitClub = ({ card }) => {
  const { omneoClient } = useAccountLayoutContext()
  const [isLoading, setIsLoading] = useState(true)
  const [walletPassUrl, setWalletPassUrl] = useState(null)
  const [isDesktop, setIsDesktop] = useState(true)
  const isApple = useMemo(() => detectApple(), [])

  useEffect(() => {
    const checkIsDesktop = () => {
      setIsDesktop(window.innerWidth >= 768)
    }
    checkIsDesktop()
    window.addEventListener('resize', checkIsDesktop)
    return () => {
      window.removeEventListener('resize', checkIsDesktop)
    }
  }, [])

  const fetchWalletPass = async () => {
    // Try to get from session storage first
    const cachedUrl = session.walletPass?.get()
    if (cachedUrl) {
      setWalletPassUrl(cachedUrl)
      setIsLoading(false)
      return
    }

    // If not in cache, fetch from API
    const response = await omneoClient.profileClient.fetchClient({
      endpoint: `/pass/generate?type=ap21_card&id=${card?.id}&device=${isApple ? 'apple' : 'google'}`,
      isJson: true,
      returnRawResponse: true
    })
    if (response.data.url) {
      setWalletPassUrl(response.data.url)
      // Cache the URL in session storage
      session.walletPass?.set(response.data.url)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    if (card?.id && !isDesktop) fetchWalletPass()
  }, [card?.id, isDesktop])

  return (
    <div className={'bg-neutrals-base p-6 md:p-10'}>
      <div className={'flex w-full flex-col justify-between gap-10 md:flex-row'}>
        <div className={'flex flex-col justify-center gap-4 md:w-1/2'}>
          <h3 className={'h3 font-bld'}>{YOUR_FIT_CLUB_DATA.heading}</h3>
          <p className={'paragraph-md text-neutrals-secondary-grey'}>{YOUR_FIT_CLUB_DATA.subtitle}</p>
          {!isDesktop && (
            <a
              href={walletPassUrl}
              target={'_system'}
              className={`btn btn-text btn-inline w-fit justify-start underline underline-offset-2 ${
                isLoading ? 'opacity-50' : ''
              }`}
            >
              {YOUR_FIT_CLUB_DATA.cta.text}
            </a>
          )}
        </div>
        <div className={'md:w-1/2'}>
          {!!card?.id && (
            <AccountFitClubCard barcode={card?.id ?? ''} memberSince={card?.memberSince} total={card?.balance ?? ''} />
          )}
        </div>
      </div>
    </div>
  )
}

function detectApple() {
  return (
    navigator.platform.startsWith('iP') ||
    (navigator.platform.startsWith('Mac') && navigator.maxTouchPoints > 4) ||
    /(Mac|iPhone|iPod|iPad)/i.test(navigator.userAgent)
  )
}
